import React, { useState } from 'react';
import AUX from '../../../../hoc/Aux_';
import { Button } from 'reactstrap';

const AppsModals = ({ open, onClose, ID, filterBy }) => {
  const [openAccordions, setOpenAccordions] = useState({});

  const toggleAccordion = (idx) => {
    setOpenAccordions((prevState) => ({
      ...prevState,
      [idx]: !prevState[idx],
    }));
  };

  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="container-fluid">
          <div
            className={`overlay ${open ? 'open' : ''} overflow-hidden`}
            id="myNav"
          >
            <div className="overlay-content py-0" style={{ padding: '20px' }}>
              <div className="slide_Headr pb-3 pt-2  border-bottom mb-4">
                <h6 className="m-0">Details</h6>
                <i
                  className="mdi mdi-close"
                  onClick={onClose}
                  style={{ fontSize: '22px', cursor: 'pointer' }}
                />
              </div>
              <div className="websites_container pr-2 pt-0">
                <div className="details_container">
                  <div className="details_tab">
                    <span>
                      <b>Project Name</b> :{' '}
                      {ID?.projectTask?.project?.name || 'N/A'}
                    </span>
                    <span>
                      <b>Task</b> : {ID?.projectTask?.name || 'N/A'}
                    </span>
                  </div>
                  <div className="details_tab">
                    <span>
                      <b>Description</b> :{' '}
                      {filterBy === 'MINUTE' &&
                      ID?.projectTaskActivity?.description
                        ? ID?.projectTaskActivity?.description
                        : ID?.description || 'N/A'}
                    </span>
                  </div>
                  <div className="details_tab">
                    <span>
                      <b>Apps & Websites</b> :{' '}
                      {(ID?.appWebsites &&
                        Array.isArray(ID?.appWebsites) &&
                        ID?.appWebsites?.join('  , ')) ||
                        '--'}
                    </span>
                  </div>
                </div>

                <div className="mt-4">
                  <b>App & Website Details</b> :
                </div>

                {ID?.appWebsiteDetails?.length > 0 ? (
                  ID?.appWebsiteDetails?.map((itm, idx) => (
                    <div
                      key={idx}
                      className="aps_accordition card card-body"
                      style={{ margin: '10px 0px' }}
                    >
                      <div className="d-flex align-items-center justify-content-between">
                        <span className="word-wrap text-break">
                          {itm?.title || 'Unknown App'}
                        </span>
                        <Button
                          size="sm"
                          color="primary"
                          outline
                          onClick={() => toggleAccordion(idx)}
                          aria-expanded={openAccordions[idx] ? 'true' : 'false'}
                        >
                          {openAccordions[idx]
                            ? 'Hide Details'
                            : 'View Details'}
                        </Button>
                      </div>
                      <div
                        className={
                          openAccordions[idx]
                            ? 'collapse mt-2 show'
                            : 'collapse'
                        }
                      >
                        <div className="card card-body">
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex flex-column ">
                              <span className="font-14">
                                App Name :{' '}
                                <span className="text-muted">{itm?.name}</span>
                              </span>
                              <span className="font-14">
                                Platform :{' '}
                                <span className="text-muted">
                                  {itm?.platform}
                                </span>
                              </span>
                            </div>
                            <div>
                              <span className="font-14">
                                Memory Usage :{' '}
                                <span className="text-muted">
                                  {itm?.memoryUsage}
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="no_data">No App/Website Details Found</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default AppsModals;
